import * as React from 'react';

import { useCustomMutation, useInvalidate, useNavigation, useNotification } from '@refinedev/core';

import { resourceNames } from '~/resources/resource-names';

export const useRejectOrderMutation = () => {
  const { open } = useNotification();
  const customMutation = useCustomMutation();
  const invalidate = useInvalidate();
  const { list: navigateToList } = useNavigation();

  const mutate = React.useCallback((id?: string, remarks?: string) => {
    customMutation.mutate(
      {
        method: 'post',
        url: '',
        values: {},
        metaData: {
          operation: 'rejectOrder',
          fields: ['id', 'remarks'],
          variables: {
            id: {
              type: 'String',
              required: true,
              value: id,
            },
            remarks: {
              type: 'String',
              required: true,
              value: remarks,
            },
          },
        },
      },
      {
        onSuccess: () => {
          open &&
            open({
              key: `${id}${new Date().getTime()}`,
              type: 'success',
              message: 'Order rejected (pending check)',
            });
          invalidate({
            resource: resourceNames.order,
            invalidates: ['list'],
          });
          navigateToList(resourceNames.order);
        },
      }
    );
  }, []);

  return {
    ...customMutation,
    mutate,
  };
};
